export default __webpack_public_path__ + "static/media/twitter-white.46955d1e.svg";